import updateInvoiceField from '../../../Services/updateInvoiceField'

export default (value) => async (dispatch) => {

  dispatch(updateInvoiceField('notes', value))

}